export default __webpack_public_path__ + "static/media/basicStar.d5f3caf4.svg";